import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { TimePicker, ChoicePicker } from "shared/components/controls";
import "shared/css/bootstrapxl.css";
import "shared/css/main.css";
import { useQueryState, useTimeRange } from "shared/hooks";
import { CollaboratorInterfacesBarChart } from "./CollaboratorInterfacesBarChart";
import { CollaboratorInterfacesChart } from "./CollaboratorInterfacesChart";
import { CollaboratorSummaryInfo } from "./CollaboratorInfo";
import { handleNavigate } from "shared/utils/timeseries-utils";
import { gridLineOptions } from "shared/constants/constants";

const EVERY_60_SECONDS = 60 * 1000;

const CollaboratorInterfaces = ({ collaborator: collaboratorName }) => {
    const [timestamp, setTimestamp] = useState(null);
    const [selected, setSelected] = useQueryState("s", null);

    // Timerange as determined by the URL search params and auto-updating
    const [timerange] = useTimeRange(EVERY_60_SECONDS);

    const [gridlines] = useQueryState("gridlines", "off");
    const showGrid = gridlines === "off" ? false : true;

    return (
        <Col md={12}>
            <Row>
                <Col>
                    <CollaboratorSummaryInfo collaboratorName={collaboratorName} />
                </Col>
            </Row>

            <hr />

            <Row>
                <Col md={8}>
                    <div style={{ float: "left" }}>
                        <ChoicePicker
                            label="Show GRIDLINES"
                            variableName="gridlines"
                            defaultValue="off"
                            options={gridLineOptions}
                        />
                    </div>
                </Col>
                <Col md={4}>
                    <div style={{ float: "right" }}>
                        <TimePicker />
                    </div>
                </Col>
            </Row>

            <hr />

            <Row>
                <Col>
                    <Row>
                        <Col md={12}>
                            <CollaboratorInterfacesChart
                                collaboratorName={collaboratorName}
                                timerange={timerange}
                                timestamp={timestamp}
                                selected={selected}
                                onTrackerChanged={(ts) => setTimestamp(ts)}
                                showGrid={showGrid}
                            />
                        </Col>
                    </Row>

                    <hr />

                    <Row>
                        <Col md={12}>
                            <CollaboratorInterfacesBarChart
                                collaboratorName={collaboratorName}
                                timerange={timerange}
                                timestamp={timestamp}
                                selected={selected}
                                onSelectionChanged={(s) => setSelected(s)}
                                onNavigate={(n) => handleNavigate(n)}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Col>
    );
};

export default CollaboratorInterfaces;
